import { useQuery } from 'react-query'
import { Box } from '@mui/material'
import BasicDetails from '../components/BasicDetails'
import ContactDetails from '../components/ContactDetails'
import { getPersonalData } from 'services/api/modules/staff-management/staffManagementDashboard'
import { countries } from 'services/api/dropdown'

const PersonalTab = ({ windowCheckEmployeeFile, employeeID }) => {
  const { data: personal } = useQuery(['employeePersonalData', employeeID], async () => {
    window.scrollTo(0, 0)
    const { data } = await getPersonalData(employeeID)
    return data
  })

  const { data: countriesList } = useQuery('countriesList', async () => {
    const { data } = await countries()
    return data
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <BasicDetails
          data={personal}
          employeeID={employeeID}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
          countriesList={countriesList}
        />
      </Box>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <ContactDetails data={personal} employeeID={employeeID} countriesList={countriesList} />
      </Box>
    </Box>
  )
}

export default PersonalTab
